<template>
    <div class="autos">
        <div class="title">
            <span>Seguros</span>
            <h1>Personales y Familia</h1>
            <div id="contactForm">
                <label for="">Conoce más sobre soluciones de seguros</label>
                <div id="hubcontactForm"></div>
            </div>
        </div>
        <div class="info">
                <h1>Seguro de Autos:</h1>
                <h1>Muévete tranquilo y con respaldo</h1>
                <p>Respaldamos tu vida y protegemos tu libertad y autonomía. Asimismo, te damos opciones para que ahorres con nosotros y hagas realidad tus sueños por medio de la consolidación de
                un patrimonio sólido.</p>
        </div>
        <div class="img">
            <center>
                <img src="@/assets/seguro-autos/img-seguridad-vial-auto.png" alt="">
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Por medio de tu movilidad realizas las actividades de tu vida cotidiana. Por eso, estamos contigo para que te desplaces de forma
                segura sintiéndote acompañado y ahorrando tiempo y dinero. Tenemos soluciones que se adaptan a los medios que escojas para tus
                recorridos, reconociendo que, más que asegurar tu vehículo, cuidamos tu vida, la de quienes te encuentras en la vía y el patrimonio que has
                construido.</p>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Todos nuestros planes te brindan el pago a los afectados por los daños que les causes en un choque o accidente (si tuviste alguna
                responsabilidad). Asimismo, buscamos una conciliación en el sitio si es posible. También, si te chocas o varas, enviamos a una persona para
                que se encargue de tu carro mientras continúas con tus actividades o, si lo prefieres, podemos acompañarte telefónicamente para que no te
                sientas solo. Además, te asistimos en un accidente de tránsito si tu salud física y mental o la de otros involucrados está en riesgo.
                <br>
                <br>
                Los planes cuentan con inspección de asegurabilidad de forma virtual o en el Centro de Servicios y en los de los aliados, , taller móvil ilimitado
                si te varas (por pinchado de llanta, daños en la batería o falta de gasolina) y atención integral en el sitio del choque o accidente para evaluar tu
                salud y gestionar la reparación de tu vehículo desde el sitio. Adicionalmente, hotel o desplazamiento si estando de viaje en carretera te varas o
                accidentas y no puedes continuar hacia tu destino.
                </p>
            </center>
        </div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'

export default {
    name: 'Seguro-Colectivo-salud',
    components: {
        Aliados
    },
    data() {
        return {
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>

<style scoped>
.title {
    background-image: url('../../../assets/servicios-bg-personas-familias.png');
    padding: 200px 200px;
    color: #fff;
    background-position: center;
    background-repeat: no-repeat;
}
.title > span {
    font-family: 'JLI';
    font-size: 40px;
}
.title > h1 {
    font-family: 'JBD';
    font-size: 50px;
}
#contactForm {
    margin-top: -100px;
    font-family: 'JR';
    background-color: #fff;
    padding: 40px;
    position: absolute;
    border-radius: 10px;
    width: 400px;
    -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    font-weight: bolder;
    right: 100px;
}
#contactForm > label {
    color: #65b24a;
    font-size: 24px;
    line-height: 25px;
}
.info {
    padding: 100px 0px;
}
.info > h1 {
    font-family: 'JBD';
    color: #65b24a;
    padding-left: 200px;
    font-size: 50px;
}
.info > p {
    font-family: 'JR';
    width: 60%;
    padding-left: 200px;
    margin-top: 10px;
    font-size: 18px;
}

.img > center > img {
    width: 70%;
}
.texto {
    width: 100%;
    padding: 10px 200px;
}
.texto > center > h1 {
    color: #2d4f98;
    font-family: 'JBD';
}
.texto > .box-title {
    margin-top: 50px;
    margin-bottom: 50px;
}
.texto > .box-title > h1 {
    color: #2d4f98;
    font-family: 'JBD';
}
.texto > .box {
    padding: 20px 20px;
    text-align: left;
    -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
    margin-bottom: 10px;
}
.texto > center > label {
    font-family: 'JBD';
    color: #65b24a;
}
.texto > center > p {
    font-family: 'JR';
}
.texto > center > p > span{
    font-weight: bold;
    color: #2d4f98;
}
@media (max-width: 1500px) {
    .title {
        padding: 200px 200px;
    }
    .info > h1 {
        padding-left: 200px;
    }
    .info > p {
        padding-left: 200px;
    }
}
@media (max-width: 1400px) {
    .title {
        padding: 200px 100px;
    }
    .info > h1 {
        padding-left: 100px;
        font-size: 30px;
    }
    .info > p {
        padding-left: 100px;
    }
}
@media (max-width: 1300px) {
    .info > h1 {
        font-size: 30px;
    }
    .info > p {
        width: 50%;
    }
    .texto {
        width: 100%;
        padding: 10px 200px;
    }
}
@media (max-width: 1100px) {
    #contactForm {
        margin-top: -100px;
        right: 50px;
    }
}
@media (max-width: 1000px) {
    .title {
        padding: 50px 0px;
        height: 400px;
        text-align: center;
    }
    #contactForm {
        margin-top: 10px;
        left: 0;
        right: 0;
        margin: auto;
    }
    .info {
        padding-top: 400px;
        width: 100%;
        text-align: center;
    }
    .info > h1 {
        width: 100%;
        padding: 10px;
        text-align: center;
    }
    .info > p {
        width: 100%;
        text-align: center;
        padding: 10px;
    }
    .texto {
        width: 100%;
        padding: 10px 100px;
    }
}
@media (max-width: 700px) {
    .texto {
        width: 100%;
        padding: 10px 50px;
    }
}
@media (max-width: 500px) {
    .texto > .box-title > h1 {
        font-size: 30px;
    }
    #contactForm {
        width: 300px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosPersonas/SeguroAutos.vue